<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col>-->
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                class="ml-7 header_btn"
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length > 0"
                @click="addRecord()"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                :to="(selectedRows[0])?'users/edit/'+selectedRows[0].user_id:''"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-clipboard-edit-outline</v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                :to="(selectedRows[0])?'users/edit/'+selectedRows[0].user_id:''"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-eye-outline</v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-7 header_btn">
                <v-icon size="28px">mdi-delete-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>

        <v-col cols="2" class="d-flex align-center">
          <!-- <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="open_doc_model_falg || open_log_model_falg" icon  dark v-bind="attrs" v-on="on">
                <v-badge overlap dot :value="search || pagination.filters.alphabet" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="400">
              <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  solo
                  clearable
                  autofocus
                  v-on:keyup.enter="search_menu = false"
                ></v-text-field>
              </v-col>
              </v-row>
            </v-card>
          </v-menu>-->
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="pagination.filters.alphabet = ''"
                :disabled="open_doc_model_falg || open_log_model_falg"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-1 header_btn"
              >
                <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                <span class="lable_class">Filter</span>
              </v-btn>
            </template>
            <v-card tile max-width="400" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item class="mt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    dense
                    outlined
                    placeholder=" "
                    clearable
                    autofocus
                    v-on:keyup.enter="search_menu = false"
                    class="mr-2"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="error"
                        @click="resetFilter()"
                        icon
                        small
                      >
                        <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Reset</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="status"
                    outlined
                    label="Status"
                    hide-details
                    class="body-2"
                    placeholder=" "
                    v-model="pagination.filters.item_active"
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>

        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openDocList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-1 header_btn"
              >
                <span class="lable_class">Documents</span>
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  overlap
                >
                  <v-icon size="28px">mdi-dresser-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Documents</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openLogList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Logs</span>
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  overlap
                >
                  <v-icon size="22px">mdi-file-document-multiple-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Logs</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            User
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background: none" flat>
      <v-card-text class="pa-0 mx-auto">
        <v-row dense style="width:100%" class="pa-0 ma-0">
          <v-col cols="2" class="pt-0 pr-0 alphabet-sort-max-width">
            <v-row dense class="alphabet-section">
              <v-col cols="12" class="text-center">
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:15px;"
                  :class="(pagination.filters.alphabet == '')?'primary':''"
                  class="text-capitalize"
                  @click="pagination.filters.alphabet = ''"
                >All</v-btn>
              </v-col>

              <v-col
                cols="12"
                v-for="(alphabet, index) in alphabets"
                :key="index"
                class="text-center pa-0"
                style="padding-top: 6px !important;"
              >
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:15px;"
                  :disabled="alphabet.disable"
                  :class="(pagination.filters.alphabet == alphabet.value)?'primary':''"
                  @click="pagination.filters.alphabet = alphabet.value"
                >{{alphabet.text}}</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header custom-width-1328"
              item-key="user_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              :show-expand="true"
              single-expand
              :expanded.sync="expanded"
              @item-expanded="expandRow"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item}">
                <tr :class="(!item.active)?'red lighten-5':''">
                  <td width="3%">
                    <v-icon
                      @click="editRecord(item.user_id,false)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td width="3%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                      @input="selectRecord(item.user_id)"
                    ></v-simple-checkbox>
                  </td>
                  <td width="25%">{{item.full_name}}</td>
                  <td width="15%">{{item.mobile_number}}</td>
                  <td
                    width="28%"
                  >{{item.email}}{{(item.email_domain)?'@'+item.email_domain.domain:''}}</td>
                  <td width="15%">{{(item.job)?item.job.job_type:''}}</td>
                  <td width="8%" class="text-center">{{(item.active)?'Yes':'No'}}</td>
                  <td width="3%">
                    <v-icon
                      @click="editRecord(item.user_id,true)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-eye-outline</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <Add />
    <Edit />
    <Upload />
    <DocList />
    <LogList />
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import Add from "./Add";
import Edit from "./Edit";
import Upload from "../document/Upload";
import DocList from "../document/List";
import LogList from "../log/List";
import { parseParams, logout } from "../../plugins/helper";
import { mapMutations, mapState } from "vuex";
export default {
  name: "UsersList",
  data() {
    return {
      open_doc_model_falg: false,
      open_log_model_falg: false,
      search: "",
      loading: false,
      filter_menu: false,
      items: {
        data: []
      },
      status: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["first_name"],
        page: 1,
        filters: {
          item_active: "1",
          alphabet: ""
        }
      },
      alphabets: [],
      expanded: [],
      days: [
        { text: "Sunday", value: 0 },
        { text: "Monday", value: 1 },
        { text: "Tuesday", value: 2 },
        { text: "Wednesday", value: 3 },
        { text: "Thrusday", value: 4 },
        { text: "Friday", value: 5 },
        { text: "Saturday", value: 6 }
      ],
      search_menu: false
    };
  },
  components: {
    Add,
    Edit,
    Upload,
    LogList,
    DocList
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("user", ["add_modal", "edit_modal"]),
    ...mapState("document", ["doc_list_modal", "refresh_doc_list"]),
    ...mapState("log", ["log_list_modal", "refresh_log_list"]),
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "first_name";
      return paginationData;
    },
    getStyles() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {
          maxWidth: "95%",
          margin: "0 auto"
        };
      } else {
        return {};
      }
    },
    headers() {
      return [
        { value: "", text: "", sortable: false, width: "3%" },
        { value: "checkbox", text: "#", sortable: false, width: "3%" },
        { value: "full_name", text: "Name", sortable: true, width: "26%" },
        { value: "", text: "Mobile", sortable: false, width: "15%" },
        { value: "", text: "Email", sortable: false, width: "28%" },
        { value: "", text: "Job Title", sortable: false, width: "15%" },
        { value: "", text: "Active", sortable: false, width: "8%" },
        { value: "", text: "", sortable: false, width: "3%" }
      ];
    }
  },
  watch: {
    doc_list_modal: function(value) {
      if (!value) {
        this.open_doc_model_falg = false;
      } else {
        this.open_doc_model_falg = true;
      }
    },
    log_list_modal: function(value) {
      if (!value) {
        this.open_log_model_falg = false;
      } else {
        this.open_log_model_falg = true;
      }
    },
    search() {
      this.getUsers();
    },
    pagination: {
      handler: function() {
        this.getUsers();
      },
      deep: true
    },
    add_modal: function(value) {
      if (!value) {
        this.pagination.filters.alphabet = "";
        this.resetFilter();
      }
    },
    edit_modal: function(value) {
      if (!value) {
        this.getUsers();
      }
    }
  },
  methods: {
    ...mapMutations("user", ["setData"]),
    ...mapMutations("document", ["setModal", "setDocumentData"]),
    ...mapMutations("log", ["setLogData"]),
    resetFilter() {
      this.search = "";
      this.pagination.filters.item_active = "1";
      this.getUsers();
    },
    selectRecord(val) {
      if (this.open_doc_model_falg || this.open_log_model_falg) {
        this.items.data.filter(item => {
          if (val == item.user_id) {
            if (this.open_doc_model_falg && this.open_log_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openDocList(item);
              this.openLogList(item);
              setTimeout(() => {
                this.openDocList(item);
                this.openLogList(item);
              }, 500);
            } else if (this.open_doc_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.openDocList(item);
            } else if (this.open_log_model_falg) {
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openLogList(item);
            }
          } else {
            item.selected = false;
          }
        });
      }
    },
    openUploader(item) {
      this.setModal(true);
      this.setDocumentData({ key: "type", value: 5 });
      this.setDocumentData({ key: "o_id", value: item.user_id });
      this.setDocumentData({ key: "items", value: this.items });
      this.setDocumentData({ key: "item", value: item });
    },
    openDocList(item) {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 5 });
      this.setDocumentData({ key: "o_id", value: item.user_id });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "form_name", value: "User" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: item.full_name });
      this.setDocumentData({ key: "customer_name", value: "" });
      this.setDocumentData({ key: "bank_name", value: "" });
      this.setDocumentData({ key: "project_name", value: "" });
      this.setDocumentData({ key: "vendor_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "USER" });
    },
    openLogList(item) {
      this.setLogData({ key: "log_list_modal", value: true });
      this.setLogData({ key: "type", value: 5 });
      this.setLogData({ key: "o_id", value: item.user_id });
      this.setLogData({ key: "item", value: item });

      this.setLogData({ key: "form_name", value: "User" });
      this.setLogData({ key: "item_name", value: "" });
      this.setLogData({ key: "job_name", value: "" });
      this.setLogData({ key: "user_name", value: item.full_name });
      this.setLogData({ key: "customer_name", value: "" });

      this.setLogData({ key: "bank_name", value: "" });

      this.setLogData({ key: "project_name", value: "" });

      this.setLogData({ key: "vendor_name", value: "" });
    },
    addRecord() {
      this.setData({ key: "add_modal", value: true });
    },
    editRecord(user_id, is_view_mode) {
      this.setData({ key: "edit_modal", value: true });
      this.setData({ key: "id", value: user_id });
      this.setData({ key: "is_view_mode", value: is_view_mode });
    },
    getAlphabets() {
      this.loading = true;
      axios.get("get_alphabets?flag=user").then(response => {
        if (response.data.status) {
          this.alphabets = response.data.data;
        }
        this.loading = false;
      });
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.user_id == itemData.item.user_id) {
            item.expande_icon = "mdi-chevron-up";
            item.selected = true;
          } else {
            item.expande_icon = "mdi-chevron-down";
          }
          return item;
        });
      } else {
        this.items.data = this.items.data.map(function(item) {
          item.expande_icon = "mdi-chevron-down";
          return item;
        });
      }
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getUsers() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios
        .get("user_list?" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.alphabets = response.data.alphabets;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    logout() {
      logout(this.$router);
    }
  },
  mounted: function() {
    //this.getAlphabets();
  }
};
</script>

<style>
</style>